export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'ServicePackage';
export const NAME = 'ServicePackage';
